import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class IntraOne_ds_get_task_by_idService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { id: number }): 
  Promise<{ result: { Id?: number, ExpectedPackagedAmount?: number } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.id)) {
      $missingRequiredInParams.push('\'id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/IntraOne/datasources/ds_get_task_by_id/get`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      id: number    }) {
        if(isNil($inParams.id)) {
          return true; 
        }
      return false;
    }
}
